import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import "./footer.css"

const Footer = ({ children }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          typeAreaWidth
        }
      }
    }
  `)

  return (
    <footer className="footer" style={{fontSize: '12px', padding: '1.5rem'}}>
      <div
        className="content has-text-centered"
      >
        <div>
          <Link to="/business">业务体系</Link>
          <span>|</span>
          <Link to="/join">加入我们</Link>
          <span>|</span>
          <Link to="/about">关于我们</Link>
          <span>|</span>
          <Link to="/contact">联系我们</Link>
        </div>
        <div>地址: 北京市海淀区小马厂6号华天大厦518室</div>
        <div>
          Copyright&copy;2011-2019 北京海华鑫安生物信息技术有限责任公司
          <a className="footer-number" href="https://beian.miit.gov.cn/" target="_blank">京ICP备13006957号-1</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
